export enum PrivateOfficeStatus {
  AVAILABLE = "available",
  UNAVAILABLE = "unavailable",
  OCCUPIED = "occupied",
  OPERATOR_CLOSED = "operator_closed",
  REMOVED = "removed",
}

export enum PrivateOfficeLifecycleState {
  OCCUPIED_BY_WOBA_CLIENT = "occupied_by_woba_client",
  OCCUPIED_BY_OWN_CLIENT = "occupied_by_own_client",
  UNDER_RENOVATION_MAINTENANCE = "under_renovation_maintenance",
  CHURN = "churn",
  SPACE_CLOSED = "space_closed",
  ROOM_NO_LONGER_EXISTS = "room_no_longer_exists",
  DUPLICATED = "duplicated",
  WRONG_RECORD = "wrong_record",
}

const TRANSIENT_LIFECYCLE_STATES = new Set([
  PrivateOfficeLifecycleState.OCCUPIED_BY_OWN_CLIENT,
  PrivateOfficeLifecycleState.UNDER_RENOVATION_MAINTENANCE,
]);

export function isTransientLifecycleState(
  state: PrivateOfficeLifecycleState,
): boolean {
  return TRANSIENT_LIFECYCLE_STATES.has(state);
}

export const MANUAL_LIFECYCLE_STATE_OPTIONS = [
  PrivateOfficeLifecycleState.OCCUPIED_BY_OWN_CLIENT,
  PrivateOfficeLifecycleState.UNDER_RENOVATION_MAINTENANCE,
  PrivateOfficeLifecycleState.ROOM_NO_LONGER_EXISTS,
] as const;

export const MANUAL_LIFECYCLE_STATE_OPTIONS_INTERNAL_USER = [
  ...MANUAL_LIFECYCLE_STATE_OPTIONS,
  PrivateOfficeLifecycleState.CHURN,
] as const;

export const LIFECYCLE_STATE_LABELS: Record<
  PrivateOfficeLifecycleState,
  string
> = {
  [PrivateOfficeLifecycleState.OCCUPIED_BY_WOBA_CLIENT]:
    "Ocupado por cliente Woba",
  [PrivateOfficeLifecycleState.OCCUPIED_BY_OWN_CLIENT]:
    "Ocupado por cliente próprio",
  [PrivateOfficeLifecycleState.UNDER_RENOVATION_MAINTENANCE]:
    "Em reforma / manutenção",
  [PrivateOfficeLifecycleState.CHURN]: "Churn",
  [PrivateOfficeLifecycleState.SPACE_CLOSED]: "Espaço fechado",
  [PrivateOfficeLifecycleState.ROOM_NO_LONGER_EXISTS]: "Sala não existe mais",
  [PrivateOfficeLifecycleState.DUPLICATED]: "Sala duplicada",
  [PrivateOfficeLifecycleState.WRONG_RECORD]: "Sala cadastrada por engano",
};

// Map between legacy numeric status (used internally) and string enum
/**
 * mysql                   mongo
 * 0,3                   available
 * 1,4,5               unavailable
 * 2                      ocuppied
 * 6                       removed
 */
export const PRIVATE_OFFICE_STATUS_MAP = {
  [PrivateOfficeStatus.AVAILABLE]: 0,
  [PrivateOfficeStatus.UNAVAILABLE]: 1,
  [PrivateOfficeStatus.OCCUPIED]: 2,
  [PrivateOfficeStatus.OPERATOR_CLOSED]: 6,
  [PrivateOfficeStatus.REMOVED]: 6,
} as const;

// Reverse mapping for converting numeric to string status
export const NUMERIC_TO_STRING_STATUS_MAP = {
  0: PrivateOfficeStatus.AVAILABLE,
  1: PrivateOfficeStatus.UNAVAILABLE,
  2: PrivateOfficeStatus.OCCUPIED,
  6: PrivateOfficeStatus.REMOVED,
} as const;

export const PRIVATE_OFFICE_STATUS_LABELS = {
  [PrivateOfficeStatus.AVAILABLE]: "Disponível",
  [PrivateOfficeStatus.UNAVAILABLE]: "Indisponível",
  [PrivateOfficeStatus.OCCUPIED]: "Ocupado",
  [PrivateOfficeStatus.OPERATOR_CLOSED]: "Fechado pelo operador",
  [PrivateOfficeStatus.REMOVED]: "Removido",
} as const;
